namespace GeniuzPOS.PosShift {
    export enum confirm {
        save = 0,
        use = 1
    }
    Serenity.Decorators.registerEnumType(confirm, 'GeniuzPOS.PosShift.confirm');
}
